import { SystemPropertyModel } from '@akin-home/system-properties';

export const SystemPropertyCreateInput = SystemPropertyModel.omit({
  __typename: true,
  createdAt: true,
  updatedAt: true,
  owner: true,
});

export const SystemPropertyUpdateInput = SystemPropertyCreateInput;
